import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/homepic.png";
import { TypeAnimation } from "react-type-animation";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function Banner() {
  const [isLoggedIn, setIsLoggenIn] = useState(false);
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setIsLoggenIn(true);
    } else {
      setIsLoggenIn(false);
    }
  }, []);
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <span className="tagline">Welcome to My Website</span>
            <h1>
              {`Hi I'm Vicky `}
              <TypeAnimation
                sequence={["Youtuber", 1000, "Gamer", 1000]}
                speed={20}
                deletionSpeed={90}
                repeat={Infinity}
              />
            </h1>
            {/* <h1>
              {`Hi I'm Anish`}
              <span className="wrap"> {text} </span>
            </h1> */}
            <p>
              I am not weak, I am a gamer. Don't wish it were easier, wish you
              were better. Needless to say, nobody is born an avid gamer
            </p>
            {/* <button onClick={() => console.log("connect")}>
              Let's Connect <ArrowRightCircle size={25} />
            </button> */}
          </Col>
          <Col xs={12} md={6} xl={5} className="mt-4">
            <img src={headerImg} alt="Header img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
